<template>
    <div class="home">
      <!-- <PopUpItem v-if="showPopUp"/> -->
      <AskForNumber/>
      <b-modal :hide-footer="offerBodyLoading" v-model="modalIsShow" modal-class="showDetails" id="offerModal" size="xl" header-close-variant="danger" centered  title="">
        <template #modal-title>
          <div class="d-flex">
            <div class="ml-auto">
              <h2>تفاصيل العرض:<span class="color-primary-dark text-center mb-3 pl-3 pr-3" v-if="offerBody">{{offerBody['offer_name']}}</span></h2>
            </div>

          </div>
        </template>
          <div v-if="offerBodyLoading" class="text-center pt-2 pb-2">
            <b-spinner class="color-primary-dark" style="width:7rem;height:7rem"></b-spinner>
          </div>
          <div v-if="!offerBodyLoading && offerBody" >
            <img :src="offerBody['offer_image_path']" style="width: 100%;">
            <div v-html="offerBody['offer_body']"></div>
          </div>

        <!--footer-->

        <template #modal-footer >
          <b-row class="w-100" style="margin-bottom:0">
            <b-col cols="9" sm="4" class="order-2 order-sm-1 p-0">

              <div class="quantity d-flex">
                <h4 class="text-secondary ml-3">الكميه:</h4>
                <b-button size="xs" @click="plusQuantity()"><font icon="plus" /></b-button>
                <span>{{quantity}}</span>
                <b-button size="xs" @click="minusQuantity"><font icon="minus" /></b-button>
              </div>
            </b-col>
            <b-col cols="3" sm="4" v-if="offerBody" class="text-center order-1 order-sm-2 d-flex  p-0">
              <h4 class="text-secondary">
                <span class="d-none d-sm-inline ">السعر:</span>
                <span class="color-primary-dark">{{Math.ceil(selectedOfferPrice)}} دينار </span>
                
              </h4>
            </b-col>

            <b-col sm="4" class="order-3 mt-2 mt-sm-0 p-0" >
              <b-row>
                <b-col cols="8">
                  <b-button v-if="!isInCard(selectedOfferId)" @click="addToShoppingCard()" variant="default"  class="add-to-card w-100" >
                    <span class="shopping-card pl-2 pr-3" >
                      <font icon="shopping-cart"/>
                    </span>
                    <span >اضف للقائمة</span>
                  </b-button>

                  <b-button v-if="isInCard(selectedOfferId)" @click="removeFromCart(selectedOfferId)" variant="default"  class="remove-from-cart w-100" >
                  <span class="shopping-card pl-2 pr-3">
                    <font icon="trash"/>
                  </span>
                    <span >حذف من السلة</span>
                  </b-button>
                </b-col>
                <b-col cols="4">
                  <b-button :href="`https://wa.me/962777864038?text=مرحبا, اريد طلب هذا المنتج: ${offerBody['offer_name']}`" variant="default" class="mainColor-btn-outlined text-light  mr-auto">
            
                    <img src="images/whatsapp.svg" width="28"/>
                  </b-button>
                </b-col>
              </b-row>


            </b-col>
          </b-row>
        </template>
      </b-modal>
      <b-container>
        <h1>الاكثر مبيعًا</h1>

        <b-row v-if="!loading.main">
          <b-col cols="6" sm="3" class="card-container mb-4" v-for="item in items" :key="item.id">
            <ItemCard :inCard="isInCard(item.id)" :itemInfo="item"/>
          </b-col>
        </b-row>

        <div class="h-100" v-if="loading.main">
          <div class="card-loading text-center" >
              <b-spinner variant="success"  style="width:7rem;height:7rem" label="Spinning"></b-spinner>
          </div>
        </div>

        <div class="text-center pt-2 pb-2 ">
          <b-spinner class="color-primary-dark" v-if="loading.moreItems"></b-spinner>
        </div>
      </b-container>
    </div>
</template>
<script type="text/javascript">
import ItemCard from '../global/ItemCard'
// import PopUpItem from '../global/PopUpItem'
import AskForNumber from '@/components/global/AskForNumber'
import {mapState, mapMutations, mapActions} from "vuex"
import axios from 'axios'
  export default {
    components:{
      ItemCard,
      AskForNumber
      // PopUpItem
    },
    name: 'Home',
    data() {
      return {
        data:[],
        items:[],
        modalIsShow:null,
        pageNumber:1,
        noMoreItems:false,
        loading:{
          moreItems:false,
          allawoTogetMore: true,
          main:true,
        }
      }
    },
    watch:{
      'modalIsShow':function() {
        if(!this.modalIsShow) {
         setTimeout(()=>{
            this.$router.push({name:'home'})
         },200)
        }
      }
    },
    computed:{
      ...mapState(["cart",
      "showPopUp",
      "offerBody",
      'offerBodyLoading',
      'quantity',
      'phone',
      'selectedOfferId',
      'selectedOfferPrice',
      
      ]),
    },
    methods: {
      ...mapMutations(['setShowPopUp','plusQuantity','minusQuantity']),
      ...mapActions(["addToCart",'removeFromCart',"getOfferBody"]),
        addToShoppingCard() {
          let item = {
            name:this.offerBody.offer_name,
            first_offer_price:this.offerBody.initial_price,
            id:this.selectedOfferId,
            image_path:this.offerBody.offer_image_path.split('easysooq.net/')[1]
          }

          this.addToCart(item)
        },
        handleScroll: function () {
          let windowScrollY       = window.scrollY;
          let widnowScrollHeight  = document.body.scrollHeight
          let windowHeight        = window.innerHeight

          let scrollFromBottom = windowScrollY - (widnowScrollHeight - windowHeight)
          if(scrollFromBottom > -300) {
            if(this.allawoTogetMore && !this.noMoreItems) {
              this.loading.moreItems = true;
               console.log('requestsent')
              this.getItems(this.pageNumber)
            }
          }
        },


      isInCard(id) {
        if(this.cart) {
          let isItemInCard = this.cart.find(product=>{
            return product.id == id || product.offer_id == id
          })
          if(isItemInCard) {
            return true;
          } else {
            return false;
          }
        }

      },
      getItems(page) {
        this.allawoTogetMore = false

        let x = new FormData();
        x.append("action", "get_offers_by_items_by_page_size_and_page_number_and_cat_optional")
        x.append("page_size", 8)
        x.append("page_number", page)

        axios.post(``,x)
        .then(res=>{
          this.pageNumber ++;
          this.loading.main = false;
          this.allawoTogetMore = true
          let respropeties = Object.keys(res.data);
          let dataInArray = []
          for(let i of respropeties){
            dataInArray.push(res.data[i])
          }
          this.items = [...this.items,...dataInArray]
          if(dataInArray.length < 8) {
            this.noMoreItems = true
          }
          this.loading.moreItems = false;
        })
        .catch(()=>{
          this.loading.moreItems = false;
          this.loading.main = false;
        })
      }
    },

    mounted() {
      this.getItems(this.pageNumber);
      if(this.$route.query.productId) {
        this.$bvModal.show('offerModal')
        this.getOfferBody(this.$route.query.productId)
      }
      
    },
    created: function () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed: function () {
        window.removeEventListener('scroll', this.handleScroll);
    }
  }
</script>
